import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  ClassStatusNumeric,
  ClientBookingStatusNumeric,
} from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'class-booking-status',
  templateUrl: './class-booking-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class ClassBookingStatusComponent implements OnInit {
  activeStatus: any;
  columnData: BehaviorSubject<any> = new BehaviorSubject(null);
  additionData: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        let index = 0;
        for (let [key, value] of Object.entries(ClientBookingStatusNumeric)) {
          // For report fields
          if (
            cData?.class_booking_status &&
            value == cData?.class_booking_status
          ) {
            this.activeStatus = { name: value, key };
          }
          index++;
        }
      },
    });
  }
}
